import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

function InputPercentage(props) {
  const { name, inputRef, onChange, decimalScale, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={({ value }) => {
        onChange({
          target: {
            name,
            value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      suffix=" %"
      decimalScale={decimalScale}
    />
  );
}

InputPercentage.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
  decimalScale: PropTypes.number,
};

InputPercentage.defaultProps = {
  decimalScale: undefined,
};

export default InputPercentage;
